module.exports = __webpack_public_path__ + "static/media/tui.7481a479.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/clients/tui.svg
// module id = 101
// module chunks = 3